export default __webpack_public_path__ + "static/media/icon-trash.8859f002.svg";